import { render, staticRenderFns } from "./company-tax.vue?vue&type=template&id=000ae087&scoped=true"
import script from "./company-tax.vue?vue&type=script&lang=js"
export * from "./company-tax.vue?vue&type=script&lang=js"
import style0 from "./company-tax.vue?vue&type=style&index=0&id=000ae087&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000ae087",
  null
  
)

export default component.exports